
    <h5 class="text-center pb-0 mb-0"> {{appareilName}}</h5>
    <span class="col-12">{{solde}}</span>
